// Configuración centralizada de la web pública de Duetto Catering
// Este archivo contiene todos los datos, textos e imágenes

export const SITE_CONFIG = {
  name: 'Duetto Catering',
  tagline: 'Catering para empresas en Madrid',
  description: 'Servicio de catering corporativo en Madrid. Desayunos, lunch y cócteles para eventos de empresa. +6 años de experiencia. Desde 6€/persona.',
  phone: '91 572 24 41',
  phoneAlt: '639 554 654',
  email: 'eventos@duettocatering.com',
  address: 'Madrid',
  foundedYear: 2018,
  minPersons: 40,
};

export const IMAGES = {
  hero: '/images/duetto/desayunos/desayunos-empresas.jpg',
  desayunos: {
    main: '/images/duetto/desayunos/desayunos-empresas.jpg',
    coffeeBreak: '/images/duetto/desayunos/coffee-break.jpg',
    oficina: '/images/duetto/desayunos/desayuno-oficina.jpg',
  },
  lunch: {
    main: '/images/duetto/lunch/lunch-catering.jpg',
    quesos: '/images/duetto/lunch/quesos-gourmet.jpg',
    buffet: '/images/duetto/lunch/buffet-empresas.jpg',
  },
  blog: {
    sostenible: '/images/duetto/blog/catering-sostenible.webp',
    desayunosCorporativos: '/images/duetto/blog/desayunos-corporativos.jpg',
    tendencias: '/images/duetto/blog/tendencias-gastronomicas.jpg',
    ventajas: '/images/duetto/blog/ventajas-catering.webp',
    intolerancias: '/images/duetto/blog/intolerancias-alimentarias.webp',
  },
};

export const CLIENTS = [
  'Ayuntamiento de Madrid',
  'eBay',
  'UPM',
  'Utopicus',
  'Repsol',
  'TikTok',
  'Got Talent',
  'UCI',
  'Decathlon',
  'Universidad Alfonso X',
];

export const SERVICES = {
  desayunos: {
    title: 'Desayunos y Coffee Break',
    slug: 'desayunos',
    shortDescription: 'Café premium 100% arábica, bollería artesanal y opciones saludables para empezar el día.',
    priceFrom: 6,
    menus: [
      {
        name: 'Coffee Break Basic',
        price: 6,
        duration: '1 hora',
        minPersons: 40,
        description: 'Opción sencilla y económica para reuniones o pausas.',
        includes: [
          '2 piezas de bollería',
          'Agua AUARA 50cl',
          'Zumo de naranja 20cl',
          'Café premium 100% arábica',
          'Leche caliente',
          'Leche sin lactosa y bebida de soja',
          'Infusiones y tés',
          'Descafeinado',
        ],
        extras: [],
      },
      {
        name: 'Coffee Break Dulce y Salado',
        price: 8.5,
        duration: '1 hora',
        minPersons: 40,
        description: 'Nuestra opción más completa con opciones dulces y saladas.',
        includes: [
          'Bandeja de jamón serrano y tomate',
          'Bandeja de jamón de pavo y queso fresco',
          'Surtido de tostas de pan',
          '1 pieza de bollería',
          'Agua AUARA 50cl',
          'Zumo de naranja 20cl',
          'Café premium 100% arábica',
          'Leche caliente, sin lactosa y soja',
          'Infusiones y tés',
          'Vajilla de loza',
        ],
        extras: [],
        popular: true,
      },
    ],
  },
  lunch: {
    title: 'Lunch y Buffet',
    slug: 'lunch',
    shortDescription: 'Comidas informales perfectas para reuniones de trabajo. Bandejas variadas para todos los gustos.',
    priceFrom: 15,
    menus: [
      {
        name: 'Lunch 5 Platos',
        price: 15,
        duration: '1h 30min',
        minPersons: 40,
        pieces: '7,5 piezas/persona',
        description: 'Opción ideal para un almuerzo ligero pero completo.',
        includes: [
          'Tortilla de patata con cebolla',
          'Surtido de quesos gourmet',
          'Tabla de ibéricos de Salamanca',
          'Salmorejo cordobés',
          'Brownie con azúcar glace',
          '1 bebida a elegir',
        ],
      },
      {
        name: 'Lunch 8 Platos',
        price: 17,
        duration: '1h 30min',
        minPersons: 40,
        pieces: '12 piezas/persona',
        description: 'Mayor variedad para eventos con más exigencia.',
        includes: [
          'Tortilla de patata con cebolla',
          'Surtido de quesos gourmet',
          'Tabla de ibéricos de Salamanca',
          'Salmorejo cordobés',
          'Empanada gallega de atún',
          'Dados de salmón marinado',
          'Focaccia de pastrami con rúcula',
          'Brownie con azúcar glace',
          '1 bebida a elegir',
        ],
        popular: true,
      },
      {
        name: 'Lunch 10 Platos',
        price: 21,
        duration: '1h 30min',
        minPersons: 40,
        pieces: '15 piezas/persona',
        description: 'Nuestra opción más completa para impresionar.',
        includes: [
          'Tortilla de patata con cebolla',
          'Tabla de ibéricos de Salamanca',
          'Salmorejo cordobés',
          'Mini pita de salmón con miel-mostaza',
          'Focaccia de pastrami con rúcula',
          'Tosta de queso de cabra con cebolla',
          'Surtido de quesos gourmet',
          'Empanada gallega de atún',
          'Dados de salmón marinado',
          'Brownie con azúcar glace',
          '1 bebida a elegir',
        ],
      },
    ],
  },
  cocteles: {
    title: 'Cócteles para Empresas',
    slug: 'cocteles',
    shortDescription: 'Servicio premium con camareros, barra libre y experiencia gastronómica completa.',
    priceFrom: 29,
    note: 'Todos los cócteles incluyen camareros (1 por cada 20 personas), barra libre de vino, cerveza y refrescos, menaje, mesas y montaje.',
    menus: [
      {
        name: 'Cóctel Frío 9 Platos',
        price: 29,
        duration: '1h 30min',
        minPersons: 40,
        pieces: '13,5 piezas/persona',
        type: 'frio',
        includes: [
          'Tortilla de patata con cebolla',
          'Tosta de queso de cabra y cebolla caramelizada',
          'Tabla de ibéricos de Salamanca',
          'Tartar de atún de aleta amarilla',
          'Gilda artesanal del cantábrico',
          'Tosta de foie marinado con mango',
          'Cucharita de ventresca con asadillo',
          'Tabla de quesos gourmet',
          'Mini carrot cake',
          'Barra libre incluida',
        ],
      },
      {
        name: 'Cóctel Frío 13 Platos',
        price: 35,
        duration: '1h 30min',
        minPersons: 40,
        pieces: '20 piezas/persona',
        type: 'frio',
        popular: true,
        includes: [
          'Todo lo del Cóctel 9 Platos +',
          'Crujiente de mascarpone y sardina',
          'Bocado de mejillón y Bonilla',
          'Maki sushi variado',
          'Tartaleta de crema y frambuesas',
        ],
      },
      {
        name: 'Cóctel Frío 16 Platos',
        price: 40,
        duration: '2 horas',
        minPersons: 40,
        pieces: '25 piezas/persona',
        type: 'frio',
        includes: [
          'Todo lo del Cóctel 13 Platos +',
          'Hummus en pan de pita',
          'Mariñeira de Gorgonzola y miel trufada',
          'Steak tartar especiado',
        ],
      },
      {
        name: 'Cóctel Caliente 9 Platos',
        price: 33.5,
        duration: '1h 30min',
        minPersons: 40,
        pieces: '14 piezas/persona',
        type: 'caliente',
        includes: [
          'Tortilla de patata con cebolla',
          'Twister de verduras con salsa agridulce',
          'Tabla de ibéricos de Salamanca',
          'Salmorejo cordobés',
          'Buñuelo de bacalao con alioli de ajo negro',
          'Tosta de foie marinado con mango',
          'Brochetas de pollo Yakitori',
          'Tabla de quesos gourmet',
          'Tarta de queso fluido',
          'Barra libre incluida',
        ],
      },
      {
        name: 'Cóctel Caliente 13 Platos',
        price: 40,
        duration: '1h 45min',
        minPersons: 40,
        pieces: '20 piezas/persona',
        type: 'caliente',
        popular: true,
        includes: [
          'Todo lo del Cóctel Caliente 9 +',
          'Gilda artesanal del Cantábrico',
          'Maki sushi variado',
          'Tatín de rabo de toro con parmesano',
          'Surtido de Macarons',
        ],
      },
      {
        name: 'Cóctel Caliente 16 Platos',
        price: 45,
        duration: '2 horas',
        minPersons: 40,
        pieces: '25 piezas/persona',
        type: 'caliente',
        includes: [
          'Todo lo del Cóctel Caliente 13 +',
          'Mariñeira de Gorgonzola y miel trufada',
          'Crujiente de mascarpone y sardina',
          'Brioche de carrillera en su jugo',
        ],
      },
    ],
  },
  vinoEspanol: {
    title: 'Vino Español',
    slug: 'vino-espanol',
    shortDescription: 'Formato tradicional con productos típicos españoles y barra libre.',
    priceFrom: 24,
    menus: [
      {
        name: 'Vino Español 3 Platos',
        price: 24,
        duration: '1 hora',
        minPersons: 40,
        includes: [
          'Tabla de ibéricos de Salamanca',
          'Tabla de quesos gourmet',
          'Cucharita de ventresca con asadillo',
          'Barra libre de vino, cerveza y refrescos',
          'Servicio de camareros incluido',
        ],
      },
      {
        name: 'Vino Español 5 Platos',
        price: 27,
        duration: '1h 30min',
        minPersons: 40,
        includes: [
          'Tabla de ibéricos de Salamanca',
          'Tabla de quesos gourmet',
          'Cucharita de ventresca con asadillo',
          'Tortilla de patata con cebolla',
          'Salmorejo cordobés',
          'Barra libre de vino, cerveza y refrescos',
          'Servicio de camareros incluido',
        ],
        popular: true,
      },
    ],
  },
};

export const BLOG_POSTS = [
  {
    id: 1,
    slug: 'catering-sostenible-empresas-madrid',
    title: 'Catering sostenible: cómo las empresas madrileñas apuestan por lo eco',
    date: '2026-01-23',
    category: 'Tendencias',
    image: IMAGES.blog.sostenible,
    excerpt: 'La forma en la que una empresa organiza sus eventos dice mucho de su cultura. El catering sostenible ha pasado de ser una tendencia a convertirse en una exigencia.',
    readTime: '5 min',
  },
  {
    id: 2,
    slug: 'desayunos-corporativos-reuniones-productivas',
    title: 'Desayunos corporativos: la clave para reuniones más productivas',
    date: '2026-01-16',
    category: 'Desayunos',
    image: IMAGES.blog.desayunosCorporativos,
    excerpt: 'Cada vez más empresas descubren que la forma de empezar el día influye directamente en el resultado de sus reuniones.',
    readTime: '4 min',
  },
  {
    id: 3,
    slug: 'tendencias-gastronomicas-corporativas-2026',
    title: 'Tendencias gastronómicas corporativas para este año',
    date: '2026-01-09',
    category: 'Tendencias',
    image: IMAGES.blog.tendencias,
    excerpt: 'El mundo de los eventos de empresa cambia al mismo ritmo que la cultura corporativa. La gastronomía es una herramienta estratégica.',
    readTime: '6 min',
  },
  {
    id: 4,
    slug: 'ventajas-contratar-catering-profesional',
    title: '5 ventajas de contratar un catering profesional',
    date: '2025-12-26',
    category: 'Consejos',
    image: IMAGES.blog.ventajas,
    excerpt: 'En un entorno corporativo exigente, cada detalle comunica la cultura de una compañía. La gastronomía se convierte en un momento clave.',
    readTime: '4 min',
  },
  {
    id: 5,
    slug: 'catering-intolerancias-alimentarias-vegano',
    title: 'Opciones de catering para intolerancias alimentarias',
    date: '2025-12-19',
    category: 'Especiales',
    image: IMAGES.blog.intolerancias,
    excerpt: 'La inclusión alimentaria ha dejado de ser un extra para convertirse en parte esencial de cualquier evento corporativo.',
    readTime: '5 min',
  },
];

export const FAQS = [
  {
    question: '¿Qué necesito tener en cuenta a la hora de contratar un catering para empresas?',
    answer: 'Debes considerar el número de asistentes, tipo de evento (desayuno, lunch, cóctel), duración prevista, posibles necesidades dietéticas especiales y contar con un servicio profesional que garantice calidad y puntualidad.',
  },
  {
    question: '¿Cuánto cuesta de media un catering para empresas en Madrid?',
    answer: 'El coste varía según el tipo de menú, duración del servicio y número de asistentes. Normalmente oscila entre 6€ y 45€ por persona. En Duetto Catering ofrecemos precios transparentes desde 6€/persona.',
  },
  {
    question: '¿Cuál es el mínimo de personas para contratar?',
    answer: 'El mínimo es de 40 personas. Para eventos más pequeños, se aplica un suplemento que varía según el tipo de servicio.',
  },
  {
    question: '¿Qué incluye el precio del catering?',
    answer: 'Todos nuestros servicios incluyen transporte a Madrid capital, montaje, menaje, mantelería y decoración. Los cócteles también incluyen servicio de camareros y barra libre.',
  },
  {
    question: '¿Ofrecéis opciones para alérgicos o vegetarianos?',
    answer: 'Sí, podemos adaptar los menús a necesidades especiales como intolerancias, alergias o dietas vegetarianas/veganas. Estas adaptaciones se presupuestan de forma personalizada.',
  },
  {
    question: '¿Cuánto tiempo de antelación necesitáis?',
    answer: 'Recomendamos contactar con al menos 1 semana de antelación para garantizar disponibilidad. Para eventos grandes o fechas especiales, sugerimos mayor previsión.',
  },
];

export const ABOUT = {
  title: 'Nuestra Historia',
  subtitle: 'Desde 2018 creando experiencias gastronómicas para empresas',
  story: `En 2018, dos profesionales con amplia experiencia en el mundo del catering decidimos empezar un nuevo proyecto desde cero. Con ilusión y mucho trabajo, nació Duetto Catering.

Desde entonces, hemos crecido de forma sostenida gracias a la confianza de nuestros clientes. Muchos de ellos repiten evento tras evento, lo que nos confirma que vamos por el buen camino.

Hoy, empresas como eBay, Repsol, TikTok, el Ayuntamiento de Madrid o la Universidad Politécnica confían en nosotros para sus eventos corporativos. Cada evento es una oportunidad para demostrar que la profesionalidad, la puntualidad y la calidad son los pilares de nuestro trabajo.`,
  values: [
    {
      title: 'Profesionalidad',
      description: 'Cada evento es importante. Nos tomamos en serio cada detalle.',
    },
    {
      title: 'Puntualidad',
      description: 'Sabemos que el tiempo en una empresa es valioso. Siempre cumplimos.',
    },
    {
      title: 'Calidad',
      description: 'Productos frescos y proveedores de confianza. Sin excepciones.',
    },
    {
      title: 'Flexibilidad',
      description: 'Nos adaptamos a tus necesidades, presupuesto y espacio.',
    },
  ],
};

export const CONDITIONS = {
  minPersons: 40,
  supplements: {
    coffeeBreak: 3.5,
    lunch: 6.5,
    coctel: 10,
  },
  transport: {
    free: 'Madrid capital y zona Noroeste',
    madridCentral: 30,
    outside: 30,
  },
  iva: 'No incluido en los precios',
  delivery: 'Máximo 30 minutos antes del evento',
  allergies: 'Se presupuestan de forma personalizada',
};
